import { IconWrapper } from '../runtime';
export default IconWrapper('single-choice', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "8",
      "cy": "7.99976",
      "r": "4",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("circle", {
    "attrs": {
      "cx": "8",
      "cy": "7.99976",
      "r": "7",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});